// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PackageList_style_wrapper__1yg2J","item":"PackageList_style_item__2jsQQ","close":"PackageList_style_close__EId9n","title":"PackageList_style_title__2Tsud"};